<template>
  <div id="data-list-list-view" class="data-list-container">
    <!-- Botão Novo Evento -->
    <div
      class="sm:hidden bg-success fixed bottom-0 left-0 w-full text-center p-6 adicionaPropostaMobile"
    >
      <div
        class="flex flex-row justify-center text-white"
        @click="newEvento()"
        v-if="$can($actionsDefault.Escrita, subjectPermission)"
      >
        <feather-icon class="" icon="PlusCircleIcon" svgClasses="h-5 w-5" />
        <span class="ml-2">Novo Sinistro</span>
      </div>
    </div>

    <div>
      <!-- Header -->
      <div
        class="flex flex-wrap-reverse items-center flex-grow justify-between pt-4"
      >
        <div class="hidden sm:flex flex-wrap-reverse items-center">
          <div
            class="py-4 px-6 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-between bg-success text-white"
            @click="newEvento()"
            v-if="$can($actionsDefault.Escrita, subjectPermission)"
          >
            <feather-icon icon="PlusCircleIcon" svgClasses="h-5 w-5" />
            <span class="ml-2">Novo Sinistro</span>
          </div>
        </div>

        <!-- Seleção das Páginas -->
        <SelectPagination
          :currentPage="currentPage"
          :itemsPerPage="itemsPerPage"
          :length="totalCount"
          @update="itemsPerPage = $event"
        />
      </div>

      <vs-card v-if="!itens.length" class="flex justify-center p-4">
        <h5 class="mt-2">Nenhum Sinistro Encontrado</h5>
      </vs-card>

      <div v-for="(item, index) in itens" :key="index">
        <CardItem :expand="true">
          <!-- HEADER -->
          <div slot="header" class="vx-col flex flex-wrap gap-1 mt-2 mb-4">
            <!-- Protocolo -->
            <vs-chip class="rounded" color="#078fcf">
              {{ item.protocolo }}
            </vs-chip>

            <!-- Tipo Apolice -->
            <vs-chip class="rounded" color="#2b50bb">
              {{ getApolicesTagText(item.tipoApolice) }}
            </vs-chip>

            <!-- Status -->
            <vs-chip
              v-if="item.nomeStatus"
              class="rounded"
              :color="item.corStatus"
            >
              {{ item.nomeStatus }}
            </vs-chip>

            <!-- Data/Hora Evento -->
            <div v-if="item.dataHoraEvento" class="divInfo flex items-center">
              {{ formataData(item.dataHoraEvento) }}
            </div>
          </div>

          <!-- BODY -->
          <template slot="body">
            <!-- Associado -->
            <div class="gap-3 mb-4 lg:w-full mr-2">
              <div class="divTitle">
                <span>{{
                  item.type === 'ASSOCIADO' ? 'SEGURADO' : item.type
                }}</span>
              </div>
              <div class="divInfo">{{ item.nome }}</div>
            </div>

            <!-- Placa -->
            <div class="gap-3 mb-4 lg:w-full mr-2">
              <div class="divTitle">PLACA</div>
              <div class="divInfo">{{ item.placa }}</div>
            </div>

            <!-- Modelo -->
            <div class="gap-3 mb-4 lg:w-full mr-2">
              <div class="divTitle">MODELO</div>
              <div class="divInfo">
                {{ item.veiculoMarca }} {{ item.veiculoModelo }}
              </div>
            </div>

            <!-- Tipo de Evento -->
            <div class="gap-3 mb-4 lg:w-full mr-2">
              <div class="divTitle">TIPO DE SINISTRO</div>
              <div class="divInfo">{{ item.tipoEvento }}</div>
            </div>

            <!-- Botões Ações -->
            <div class="dropdownAcoes">
              <vs-dropdown vs-trigger-click class="flex cursor-pointer">
                <div
                  class="rounded-full cursor-pointer"
                  style="background: #078fcf"
                >
                  <vs-icon
                    round
                    class="m-1"
                    size="medium"
                    color="white"
                    icon="more_horiz"
                  ></vs-icon>
                </div>

                <!-- Menu de Opções -->
                <vs-dropdown-menu style="width: 250px">
                  <!-- Editar Evento -->
                  <vs-dropdown-item
                    :to="`editar-evento/${item.idEvento}`"
                    v-if="$can($actionsDefault.Escrita, subjectPermission)"
                  >
                    <div class="flex gap-3">
                      <vs-icon
                        color="success"
                        icon-pack="feather"
                        icon="icon-edit"
                      >
                      </vs-icon>
                      <span>Editar Sinistro</span>
                    </div>
                  </vs-dropdown-item>

                  <!-- Analise Evento -->
                  <vs-dropdown-item
                    :to="`evento-analise/${item.idEvento}`"
                    v-if="$can($actionsDefault.Leitura, 'Análise de Eventos')"
                  >
                    <div class="flex gap-3">
                      <vs-icon
                        color="success"
                        icon-pack="feather"
                        icon="icon-info"
                      >
                      </vs-icon>
                      <span>Análise do Sinistro</span>
                    </div>
                  </vs-dropdown-item>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </template>

          <!-- DETAILS -->
          <template slot="details">
            <!-- VALOR DE REPARO -->
            <div class="mb-4 lg:w-1/2 mr-2">
              <div class="divTitle">VALOR DE REPARO</div>
              <div class="divInfo">{{ formataReal(item.valorReparo) }}</div>
            </div>

            <!-- COTA DE PARTICIPAÇÃO -->
            <div class="mb-4 lg:w-1/4 mr-2">
              <div class="divTitle">FAIXA</div>
              <div class="divInfo">{{ item.porcentagemParticipacao }}%</div>
            </div>

            <!-- VALOR DA COTA -->
            <div class="mb-4 lg:w-1/2 mr-2">
              <div class="divTitle">VALOR DA FRANQUIA</div>
              <div class="divInfo">
                {{ formataReal(item.cotaParticipacao) }}
              </div>
            </div>

            <div class="mb-4 lg:w-full mr-2">
              <div class="divTitle">ANALISTA - SINISTRO</div>
              <div class="divInfo">{{ item.analistaEvento }}</div>
            </div>

            <div class="mb-4 lg:w-full mr-2">
              <div class="divTitle">ANALISTA - REPARO</div>
              <div class="divInfo">{{ item.analistaReparo }}</div>
            </div>

            <!-- ACIONAMENTO PARA TERCEIRO -->
            <div class="mb-4 lg:w-1/4 mr-2">
              <div v-if="item.type === 'ASSOCIADO'">
                <div class="divTitle">TERCEIRO</div>
                <div class="divInfo">{{ item.acionamentoParaTerceiro }}</div>
              </div>
            </div>
          </template>
        </CardItem>
      </div>
    </div>

    <vs-pagination
      :max="screenWidth < 650 ? 5 : 9"
      v-if="countPage"
      :total="countPage"
      v-model="currentPage"
    ></vs-pagination>
  </div>
</template>

<script>
import moment from 'moment';

import service from './../../../../../services';
import notify from '../../../../../utils/notify';
import functions from './../../../../../utils/functions';
import { PRODUCT_TAG } from './../../../../../constants/tipo.apolice';

// Component
import SelectPagination from '../../../../../utils/list/header/SelectPagination.vue';
import CardItem from './card-item.vue';

export default {
  props: ['filtro', 'subjectPermission'],
  components: {
    SelectPagination,
    CardItem,
  },
  data() {
    return {
      isMounted: false,
      itens: [],

      itemsPerPage: 10,
      currentPage: 1,
      countPage: 0,
      totalCount: 0,

      screenWidth: null,
      formataReal: functions.formataReal,
    };
  },
  watch: {
    currentPage() {
      this.buscaDados();
    },
    itemsPerPage() {
      this.buscaDados();
    },
  },
  methods: {
    newEvento() {
      this.$router.push('/novo-evento');
    },
    async buscaDados() {
      let objSend = {
        currentPage: this.currentPage,
        itemsPerPage: this.itemsPerPage,
      };

      if (this.filtro) {
        objSend = {
          ...objSend,
          ...this.filtro,
          dataInicial: this.filtro.dataInicial
            ? moment(this.filtro.dataInicial).format('YYYY-MM-DD')
            : null,
          dataFinal: this.filtro.dataFinal
            ? moment(this.filtro.dataFinal).format('YYYY-MM-DD')
            : null,
        };
      }

      try {
        this.$vs.loading();
        const res = await service.post('eventos2', '', objSend);

        this.itens = res.data.eventos;
        this.totalCount = res.data.count;

        this.countPage = this.totalCount / this.itemsPerPage;
        if (this.countPage % 1 != 0) {
          this.countPage++;
        }
        this.countPage = parseInt(this.countPage);
      } catch (error) {
        notify.notifyFail(this.$vs, error);
      } finally {
        this.$vs.loading.close();
      }
    },
    formataData(data) {
      return moment(data).format('DD/MM/YYYY HH:mm');
    },
    getApolicesTagText(id) {
      return PRODUCT_TAG[id];
    },
  },
  created() {
    this.buscaDados();
  },
  mounted() {
    this.isMounted = true;
    this.screenWidth = window.innerWidth;
  },
};
</script>

<style src="./../../../../../assets/css/listCard.css"></style>

<style>
.vs-tooltip,
.con-vs-tooltip {
  z-index: 99999;
}
</style>

<style lang="scss">
@media print {
  #content-area {
    margin-left: 0px;
  }
  .navbar-sticky .router-view .router-content {
    margin-top: 0px;
  }
  .vs-content-sidebar,
  .con-pagination-table,
  #data-list-list-view .vs-con-table .vs-table--header,
  .the-footer,
  .vs-navbar {
    display: none !important;
  }
  body,
  .vs-con-table .vs-con-tbody {
    background-color: #ffffff;
  }
  .vx-card,
  #data-list-list-view .vs-con-table .vs-table tr {
    box-shadow: none !important;
  }
  .td-check {
    visibility: hidden;
  }
}

#data-list-list-view {
  .vs-con-table {
    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

.vs-button.includeIcon {
  float: left;
  margin-right: 5px;
}

.vs-chip-bg-pink {
  background-color: rgb(255, 68, 0);
}

.vs-chip-bg-blue {
  background-color: navy;
}

@media screen and (max-width: 900px) {
  .dropdownAcoes {
    padding-right: 1rem;
  }
}
</style>

<style scoped>
@import url('https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css');
</style>
